import { combineReducers } from "redux";

// Front
import Layout from "./layout/reducer";

// Authentication
import Login from "./auth/login/reducer";
import Account from "./auth/register/reducer";
import ForgetPassword from "./auth/forgetpwd/reducer";
import Profile from "./auth/profile/reducer";

//E-commerce
import ecommerce from "./e-commerce/reducer";

//Calendar
import calendar from "./calendar/reducer";

//chat
import chat from "./chat/reducer";

//crypto
import crypto from "./crypto/reducer";

//invoices
import invoices from "./invoices/reducer";

//projects
import projects from "./projects/reducer";

//tasks
import tasks from "./tasks/reducer";

//contacts
import contacts from "./contacts/reducer";

//mails
import mails from "./mails/reducer";

//LegalEntity
import LegalEntityList from './legal-entity/reducer'

//Dashboard
import Dashboard from "./dashboard/reducer";

//User
import User from "./user/reducer";

//Dashboard saas
import DashboardSaas from "./dashboard-saas/reducer";

//Media buyers budget
import MediaBuyerBudgets from "./mediabuyers/mediabuyerbudget/reducer";

//Positions
import Positions from "./positions/reducer";

//Media buyers plans
import MediaBuyerPlans from "./mediabuyers/mediabuyerplans/reducer";

// Campaign list
import CampaignsList from "./campaigns/list/reducer";
import CampaignInfo from "./campaigns/campaign-info/reducer";

//Clients list
import CampaignFormatList from "./campaigns/formats/reducer";
import CampaignStatuses from "./campaigns/statuses/reducer";
import Offers from "./offers/reducer";
import Events from "./events/reducer";
import CampaignSourceList from "./campaigns/sources/reducer";
import CampaignDirectionTypeList from "./campaigns/direction-types/reducer";

//Reporting
import Reporting from "./reporting/reducer";

//Client
import Clients from "./clients/reducer";

//Apps
import Apps from "./apps/reducer";

//Formulas
import PaymentFormulas from "./payment-formula/reducer";

//Users
import UsersList from "./user/user-list/reducer";
import CampaignDeviceTypeList from "./campaigns/device-types/reducer";
import CampaignOfferTypeList from "./campaigns/offer-types/reducer";
import CampaignMediaBuyerList from "./campaigns/media-buyers/reducer";
import CampaignCustomNamesList from "./campaigns/custom-names/reducer";
import InvoiceList from "./invoices/reducer";
import CampaignAdvertisingAccountList from "./campaigns/advertising-accounts/reducer";
import Meta from "./meta/reducer";
import CampaignCashbackList from "./campaigns/cashbacks/reducer";
import ContractorList from "./contractors/reducer";
import Integration from "./integration/reducer";
import Mapper from "./mapper/reducer";
import PlanList from "./plans/reducer"
import CohortReportList from "./cohort-reports/reducer"

// Salary Bonuses
import SalaryBonuses from "./salary-bonuses/reducer"

// Invoice templates
import InvoiceTemplates from "./invoice_templates/reducer"

// Bank details
import BankDetails from "./bank-details/reducer"

// Bank corespondents
import BankCorespondent from "./bank-corespondents/reducer"

// Bank uploading
import BankUploading from "./bank-uploading/reducer"

// Transactions
import transactions from "./transactions/reducer";

// Notifications
import Notifications from "./notifications/reducer";

// Warehouse
import Warehouse from "./warehouse/reducer";

// User ACtions
import UserActions from "./user-actions/reducer"

// User Payout Conditions
import UserPayoutConditions from "./user-payout-conditions/reducer"

// User Salary Conditions
import UserSalaryConditions from "./user-salary-conditions/reducer"

// Service Providers
import ServiceProviders from "./service-provider/reducer"


const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  Notifications,
  ForgetPassword,
  Profile,
  // ecommerce,
  // calendar,
  // chat,
  // mails,
  // crypto,
  // invoices,
  // projects,
  // tasks,
  // contacts,
  Dashboard,
  DashboardSaas,
  MediaBuyerBudgets,
  MediaBuyerPlans,
  CampaignsList,
  CampaignInfo,
  User,
  UsersList,
  Clients,
  Apps,
  PaymentFormulas,
  CampaignFormatList,
  Offers,
  Events,
  Positions,
  CampaignStatuses,
  CampaignSourceList,
  CampaignDirectionTypeList,
  CampaignDeviceTypeList,
  CampaignOfferTypeList,
  CampaignCustomNamesList,
  CampaignMediaBuyerList,
  InvoiceList,
  CampaignAdvertisingAccountList,
  CampaignCashbackList,
  Reporting,
  Meta,
  ContractorList,
  Integration,
  Mapper,
  LegalEntityList,
  PlanList,
  CohortReportList,
  SalaryBonuses,
  InvoiceTemplates,
  BankDetails,
  BankCorespondent,
  BankUploading,
  transactions,
  Warehouse,
  UserActions,
  UserPayoutConditions,
  UserSalaryConditions,
  ServiceProviders
});

export default rootReducer;
